/**
 * AES采集SDK Web版本
 */
import Core from './core';
import getRecordingInfo from './xreplay/index';
import { reqIdleCallback, assign, getIsDebug } from './utils';
var APLUS_LOGKEY = '/aes.1.1';

// 是否支持UT，支持UT时断网也直接发送埋点
// const SUPPORT_UT = navigator.userAgent.indexOf('WindVane') !== -1;
// 离线时最多缓存的埋点条数
var MAX_CACHE_QUEUE = 500;

// 开启调试 log
var is_debug = getIsDebug();

// 获取spm
var getSPMAB = function getSPMAB() {
  if (window.goldlog && goldlog.spm_ab) {
    return goldlog.spm_ab;
  }
  var siteSPM;
  var spmMeta = document.querySelector('meta[name="spm-id"]') || document.querySelector('meta[name="data-spm"]');
  if (spmMeta) {
    siteSPM = spmMeta.content;
    if (siteSPM && siteSPM.indexOf('.') !== -1) {
      return siteSPM.split('.');
    }
  }
  var pageSPM = document.body && document.body.getAttribute('data-spm');
  if (siteSPM && pageSPM) {
    return [siteSPM, pageSPM];
  }
  return [];
};
function AES(aes_config) {
  var _this = this;
  this._offlineQueue = [];
  var SPM_AB = getSPMAB();
  var config = {
    // is_top: window.top === window,
    //0 TYPE_NAVIGATE：The page was accessed by following a link, a bookmark, a form submission, a script, or typing the URL in the address bar.
    //1 TYPE_RELOAD：The page was accessed by clicking the Reload button or via the Location.reload() method.
    //2 TYPE_BACK_FORWARD：The page was accessed by navigating into the history.
    //255 TYPE_RESERVED：Any other way.
    // nav_t: window.performance?.navigation?.type,
    // visible: document.hidden !== true,
    // memory: navigator.deviceMemory,
    // cpu: navigator.hardwareConcurrency,
    title: document.title,
    spm_a: SPM_AB[0],
    spm_b: SPM_AB[1],
    hash: location.hash,
    dpi: window.devicePixelRatio,
    sr: "".concat(window.screen.width, "x").concat(window.screen.height),
    // referer: document.referrer,
    // ua: navigator.userAgent,
    platform: 'web',
    language: navigator.language,
    // 调试模式
    debug: is_debug,
    // 全局队列的命名空间
    queueGlobalName: 'AES_QUEUE'
  };

  // meta上的配置覆盖
  var configMeta = document.querySelector('meta[name="aes-config"]');
  if (configMeta) {
    try {
      var configStr = configMeta.getAttribute('content');
      if (configStr) {
        configStr.split('&').forEach(function (item) {
          var kv = item.split('=');
          var k = kv[0];
          var v = decodeURIComponent(kv[1]);
          if (k.indexOf('.') !== -1) {
            var k1 = k.split('.')[0];
            var k2 = k.split('.')[1];
            if (!config[k1]) {
              config[k1] = {};
            }
            config[k1][k2] = v;
          } else {
            config[k] = v;
          }
        });
      }
    } catch (ex) {}
  }

  // window.AES_CONFIG内的配置为公共配置，多个实例时共享
  // 初始化时传递的配置优先级更高
  if (window.AES_CONFIG) {
    config = assign(config, AES_CONFIG);
  }
  if (aes_config) {
    config = assign(config, aes_config);
  }
  Core.call(this, config);

  // Hash变化
  window.addEventListener('hashchange', function () {
    _this.setConfig('hash', location.hash);
  });
  // 网络变化
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    var updateNet = function updateNet() {
      // 更新网络状态
      _this.setConfig({
        downlink: connection.downlink,
        net_type: connection.effectiveType
      });
      // 联网后发送缓存的埋点
      if (navigator.onLine && _this._offlineQueue.length) {
        _this._offlineQueue.forEach(function (item) {
          reqIdleCallback(function () {
            _this.send(item);
          });
        });
        _this._offlineQueue = [];
      }
    };
    updateNet();
    connection.addEventListener('change', updateNet);
  }
  // title 变化，用Object.defineProperty会导致浏览器的默认行为丢失
  // 监听类型不兼容时会报错，所以加try catch
  // characterData\subtree：document.querySelector('title').childNodes[0].nodeValue = ''
  try {
    var observer = function observer() {
      var title = document.querySelector('title');
      if (!title) {
        return;
      }
      new MutationObserver(function () {
        _this.setConfig('title', document.title);
      }).observe(title, {
        childList: true,
        characterData: true,
        subtree: true
      });
    };
    if (document.querySelector('title')) {
      observer();
    } else {
      document.addEventListener('DOMContentLoaded', observer);
    }
  } catch (ex) {}

  // 发送采集脚本加载完成前的埋点
  // 多实例时，如果没有定义queueGlobalName，则会被多个实例消费
  var queue = config.queueGlobalName;
  if (Object.prototype.toString.call(window[queue]) === '[object Array]') {
    window[queue].forEach(function (item) {
      if (typeof item === 'function') {
        item(_this);
      } else {
        _this[item.action].apply(_this, item.arguments);
      }
    });
  } else {
    window[queue] = [];
  }
  var originPush = window[queue].push;
  window[queue].push = function (item) {
    if (typeof item === 'function') {
      item(_this);
    } else {
      _this[item.action].apply(_this, item.arguments);
    }
    if (Array.prototype.push !== originPush) {
      originPush(item);
    }
  };

  // TODO: 再验证下，618后上
  // 在页面卸载前清空缓存的埋点，避免因为requestIdleCallback的逻辑影响埋点到达率
  // page life cycle说明：https://developer.chrome.com/blog/page-lifecycle-api/
  // document.addEventListener('visibilitychange', ()=>{
  //     console.log('send on visibilitychange');
  //     document.hidden && this._sendAll();
  // })
}
AES.prototype = function () {
  var F = function F() {};
  F.prototype = Core.prototype;
  return new F();
}();
AES.prototype.constructor = AES;

/**
 * 在每次调用log方法前更新配置
 */
AES.prototype.log = function () {
  var config;
  // 更新spm，单页应用下spm可能动态更新
  if (window.goldlog) {
    var spm_ab = goldlog.spm_ab;
    if (spm_ab) {
      if (this.getConfig('spm_a') !== spm_ab[0]) {
        (config || (config = {}))['spm_a'] = spm_ab[0];
      }
      if (this.getConfig('spm_b') !== spm_ab[1]) {
        (config || (config = {}))['spm_b'] = spm_ab[1];
      }
    }
  }

  // 更新origin_url
  var newURL = location.href;
  if (newURL !== this.getConfig('origin_url')) {
    config || (config = {});
    config.origin_url = location.href;
  }

  // 更新xreplay
  var xreplayParams = getRecordingInfo();
  if (xreplayParams) {
    var xreplay_id = xreplayParams.appKey + ',' + xreplayParams.recordingId;
    if (this.getConfig('xreplay_id') !== xreplay_id) {
      (config || (config = {}))['xreplay_id'] = xreplay_id;
    }
  }
  // setConfig会进行队列检查，尽可能少执行
  config && this.setConfig(config);
  Core.prototype.log.apply(this, arguments);
};

/**
 * 底层的发送埋点逻辑
 * @method send
 * @params gokey {String} 需要发送的数据
 * @private
 */
AES.prototype.send = function (gokey) {
  if (navigator.onLine) {
    var _window$goldlog;
    var args = [APLUS_LOGKEY, 'EXP', gokey, 'POST'];
    if ((_window$goldlog = window.goldlog) !== null && _window$goldlog !== void 0 && _window$goldlog.record) {
      goldlog.record.apply(goldlog, args);
      this._print('[AES] send', args);
    } else {
      window.goldlog_queue || (window.goldlog_queue = []);
      goldlog_queue.push({
        action: "goldlog.record",
        arguments: args
      });
      typeof console !== 'undefined' && console.warn('[AES] 未监测到Aplus SDK');
    }
  } else {
    // 防止内存溢出
    if (this._offlineQueue.length > MAX_CACHE_QUEUE) {
      this._offlineQueue.shift();
    }
    this._offlineQueue.push(gokey);
  }
};
export default AES;